<template>
	<div
		class="g-block-divider-double-mixed g-block-divider-padding"
		:class="{
			'g-block-divider-double-mixed--edit': editable,
			'is-active': editable && active,
			'g-block-divider-double-mixed--h5': h5,
			'g-block-divider-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-divider-double-mixed__lines">
			<span
				class="g-block-divider-double-mixed__line g-block-divider-double-mixed__line--thin"
				:style="{ background: themeColor }"
				aria-hidden="true"
			></span>
			<span
				class="g-block-divider-double-mixed__line g-block-divider-double-mixed__line--thick"
				:style="{ background: themeColor }"
				aria-hidden="true"
			></span>
		</div>
	</div>
</template>

<script>
	import { dividerMixin } from '../shared/dividerMixin.js';

	export default {
		name: 'GBlockDividerDoubleMixed',
		mixins: [dividerMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/dividerEditShell.less';

	.g-block-divider-double-mixed {
		.divider-block-edit-shell();
	}

	.g-block-divider-double-mixed__lines {
		display: flex;
		flex-direction: column;
		gap: 6px;
	}

	.g-block-divider-double-mixed__line {
		display: block;
		width: 100%;

		&--thin {
			height: 1px;
		}

		&--thick {
			height: 3px;
		}
	}

	.g-block-divider-double-mixed--h5 {
		.g-block-divider-double-mixed__lines {
			gap: 0.12rem;
		}

		.g-block-divider-double-mixed__line--thin {
			height: 0.02rem;
		}

		.g-block-divider-double-mixed__line--thick {
			height: 0.06rem;
		}
	}
</style>
